import axios from 'axios';

async function read(url) {
	const { data } = await axios.get(url);
	if (!data || typeof data !== 'object')
		throw new Error(
			'The server returned an unexpected response. Please try again.'
		);
	return data;
}
async function write(url, payload) {
	const { data } = await axios.post(url, payload);
	if (!data || Number(data.result) !== 1)
		throw new Error('Your changes could not be saved. Please try again.');
	return data;
}
export const getUser = guid =>
	read(`/api/discord_card_user?guid=${encodeURIComponent(guid)}`);
export const getUserCards = guid =>
	read(`/api/discord_card_list?guid=${encodeURIComponent(guid)}`);
export const getWatchCatalog = () => read('/api/sets?scope=watch');
export const getCardNameMatches = (search, category, productType) =>
	read(
		`/api/card_name_and_sets?search=${encodeURIComponent(search)}${
			category ? `&category=${category}` : ''
		}${
			productType
				? `&product_type=${encodeURIComponent(productType)}`
				: ''
		}`
	);
export const getCardSets = search =>
	read(`/api/card_name?search=${encodeURIComponent(search)}`);
export const addDiscordUserCardWatch = (guid, cardName, sets) =>
	write('/api/add_discord_user_card', { guid, card_name: cardName, sets });
export const updateDiscordUserCardWatch = (guid, cardName, sets) =>
	write('/api/update_discord_user_card', { guid, card_name: cardName, sets });
export const updateDiscordUserSettings = (guid, settings) =>
	write('/api/update_discord_user_settings', { guid, settings });
export const deleteDiscordUserCardWatch = (guid, cardName) =>
	write('/api/delete_discord_user_card', { guid, card_name: cardName });
